const googleTagFire = (buttonName, action, eventData) => {
  // If eventData is an object with 'event' property, it's a custom event structure
  // Push it directly to dataLayer as-is
  if (eventData && typeof eventData === "object" && eventData.event) {
    window?.dataLayer.push(eventData);
    return;
  }

  // Otherwise, use the original button click format
  const payload = {
    clickedEventActionName: buttonName,
    clickedEventName: action ?? "Button-Click",
    clickedEventResponse: eventData ?? null,
  };
  window?.dataLayer.push(payload);
};

export default googleTagFire;
